import { apiClient } from '@/api/api-client';
import { ApiResponse } from '@/types/api-response';
import { AbaRecord } from '@/types/aba-record-type';

const ABA_RECORD_ENDPOINTS = ['/aba', '/aba-records'];

export async function fetchAbaRecord(id: string): Promise<ApiResponse<AbaRecord>> {
  let lastResponse: ApiResponse<AbaRecord> | null = null;

  for (const endpoint of ABA_RECORD_ENDPOINTS) {
    const response = await apiClient.get<AbaRecord, {}>(`${endpoint}/${id}`, {});

    if (response.success) {
      return response;
    }

    lastResponse = response;
    if (response.status !== 404) {
      return response;
    }
  }

  return lastResponse as ApiResponse<AbaRecord>;
}

export async function checkAbaOrder(orderId: string): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.get<any, {}>(`aba/check/${orderId}`, {});
    return response;
  } catch (error: any) {
    throw error;
  }
}

